import React from 'react';
import { ImageStyle, StyleSheet } from 'react-native';
import YellowStar from '@/assets/icon/yellow_star.png';
import GreyStar from '@/assets/icon/grey_star.png';
import Flex from '@kibt/meta-ui-krn/lib/components/Flex';
import Image from '@kds/image';

export interface IStarGroupProps {
    yellowStarCount?: number;
    totalStarCount?: number;
    startStyle?: ImageStyle;
}

const style = StyleSheet.create({"starIcon":{"width":"3.6231884057971016rem","height":"3.6231884057971016rem","marginRight":"0.9661835748792271rem"}});

const StarGroup = (props: IStarGroupProps) => {
    const { yellowStarCount = 0, totalStarCount = 5 } = props;

    // 1: 黄星 0: 灰星
    const getStarList = () => {
        return Array.from({ length: totalStarCount }, (_, index) => (index < yellowStarCount ? 1 : 0));
    };

    return (
        <Flex>
            {getStarList().map(item => (
                <Image style={[style.starIcon, props?.startStyle]} source={item === 1 ? YellowStar : GreyStar} />
            ))}
        </Flex>
    );
};

export default StarGroup;
